
import { BookingType } from "@/lib/supabase/types";
import { parseISO, addHours } from "date-fns";
import { toZonedTime } from 'date-fns-tz';

export const ARMENIA_TIMEZONE = 'Asia/Yerevan';

export const isBookingPast = (booking: BookingType): boolean => {
  if (!booking.classDate || !booking.classTime) return false;
  
  try {
    const datePart = parseISO(booking.classDate);
    
    let hours = 0;
    let minutes = 0;
    const timeMatch = booking.classTime.match(/(\d+):(\d+)\s*(AM|PM)?/i);
    
    if (timeMatch) {
      hours = parseInt(timeMatch[1], 10);
      minutes = parseInt(timeMatch[2], 10);
      
      if (timeMatch[3]?.toUpperCase() === 'PM' && hours < 12) {
        hours += 12;
      }
      if (timeMatch[3]?.toUpperCase() === 'AM' && hours === 12) {
        hours = 0;
      }
    }
    
    const classDate = new Date(datePart);
    classDate.setHours(hours, minutes, 0, 0);
    
    const classDateAMT = toZonedTime(classDate, ARMENIA_TIMEZONE);
    
    const nowAMT = toZonedTime(new Date(), ARMENIA_TIMEZONE);
    
    const classEndTime = addHours(classDateAMT, 3);
    
    return nowAMT > classEndTime;
  } catch (error) {
    console.error('Error checking if booking is past:', error);
    return false;
  }
};

export const groupBookingsByClass = (bookings: BookingType[] = []) => {
  if (bookings.length === 0) return [];
  
  const grouped: {
    classId: string;
    className: string;
    classDay: string;
    classTime: string;
    classDate?: string;
    bookings: BookingType[];
  }[] = [];
  
  bookings.forEach(booking => {
    const existingGroup = grouped.find(group => group.classId === booking.classId);
    
    if (existingGroup) {
      existingGroup.bookings.push(booking);
    } else {
      grouped.push({
        classId: booking.classId,
        className: booking.className || '',
        classDay: booking.classDay || '',
        classTime: booking.classTime || '',
        classDate: booking.classDate,
        bookings: [booking]
      });
    }
  });
  
  return grouped;
};
